import { Box, Grid, Paper, Typography } from '@mui/material';

import React from 'react';
import {
  AppFormikSelectWithKeys,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const BasicIdentification: React.FC<any> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  console.log(purpose);
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">Basic Identification</Typography>
        <Box className="paper-form-input-content">
          <Grid spacing={4} container className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="server_name"
                placeholder="Enter server name"
                outerLabel
                label="Server Name*"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="business_owner"
                placeholder="Enter business owner"
                outerLabel
                label="Business Owner"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="technical_owner"
                placeholder="Enter technical owner"
                outerLabel
                label="Technical Owner"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="team_or_function"
                placeholder="Enter team / function"
                outerLabel
                label="Team / Function"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="environment_scope"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="environment_scope-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                titleKey="title"
                valueKey="value"
                outerLabel
                placeholder="Select..."
                notEmphasized
                notSelectablePlaceholder
                label="Environment Scope"
                items={[
                  { title: 'Dev', value: 'dev' },
                  { title: 'Test', value: 'test' },
                  { title: 'Prod', value: 'prod' },
                ]}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="hosting_model"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="hosting_model-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select..."
                notEmphasized
                notSelectablePlaceholder
                label="Hosting Model"
                titleKey="title"
                valueKey="value"
                items={[
                  { title: 'Vendor Hosted', value: 'vendor-hosted' },
                  { title: 'Self Hosted', value: 'self-hosted' },
                  { title: 'Hybrid', value: 'hybrid' },
                ]}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="status"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="status-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select Status"
                notEmphasized
                notSelectablePlaceholder
                label="Status"
                titleKey="title"
                valueKey="value"
                items={[
                  { title: 'Proposed', value: 'proposed' },
                  { title: 'Pilot', value: 'pilot' },
                  { title: 'Approved', value: 'approved' },
                  { title: 'Restricted', value: 'restricted' },
                  { title: 'Retired', value: 'retired' },
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="short_description"
                placeholder="Enter short description"
                label="Short Description"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="primary_use_cases"
                placeholder="Enter primary use cases"
                label="Primrary Use Cases"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default BasicIdentification;
